import React from "react";
import multiLang from "../../lang/lang.json";

export default ({ language }) => {
  const { lang, dir } = language;

  return (
    <div className={dir === "rtl" ? "rtl" : "ltr"}>
      <center>
        <h1>{multiLang["003"][lang]}</h1>
      </center>
    </div>
  );
};
